import React, { useCallback, useEffect, useRef, useState } from "react";

import categoryViewModel from "./CategoryViewModel";

import { Button } from "primereact/button";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

import { FilterMatchMode } from "primereact/api";

import { IconName, library } from '@fortawesome/fontawesome-svg-core';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './Category.css';

import {
  faBaby,
  faBath,
  faBriefcase,
  faCamera,
  faCarSide,
  faCompactDisc,
  faCouch,
  faDesktop,
  faDog,
  faDumbbell,
  faGamepad,
  faHeart,
  faHelmetSafety,
  faHouse,
  faLaptop,
  faOilCan,
  faPlug,
  faSatellite,
  faShirt,
  faTooth,
  faTree,
  faUser,
  faUserMd,
  faUtensils,
  faVirus,
  faWarehouse,
  faWeightHanging,
  faWineBottle,
  faScrewdriverWrench,
  faFire,
  faGear,
  faMobileScreen,
  faLightbulb,
  faSolarPanel,
  faCarBattery,
  faMusic,
  faBell,
  faPrint,
  faPen,
  faGift,
  faCameraRetro,
  faPalette,
  faClock,
  faWind

} from '@fortawesome/free-solid-svg-icons';
 
import { Avatar } from "primereact/avatar";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { Controller, useForm } from "react-hook-form";
import { useToast } from "../../../../Shared/hook/useToast";
import { Category } from "../../Domain/Model/Category";

interface ColumnMeta {
  field: string;
  header: string;
  editable: boolean;
}

interface IconList {
  name: string;
  icon: any;
  codeIcon: string;
}

let emptyProduct: Category = {
  id: '',
  name: '',
  icon: ''
  
};

export const CategoryView = ()=> {
  const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});
  const [iconCodeState, setIconCodeState] = useState<string>();
  // const toast = useRef<Toast>(null);
  const { showSuccess, showError, showWarn, showInfo } = useToast();
  const [categoryDataUpdate, setCategoryDataUpdate] = useState<Category>(emptyProduct);

  const defaultValues = { 
    name: '',
    icon: '',
};
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleListIcon, setVisibleListIcon] = useState<boolean>(false);
  const {
    getCategories,
    createCategory,
    removeCategory,
    updateCategory,
    onChangeCategory,
    categories,
  } = categoryViewModel();

  const icons: IconList[] = [
    {name: 'bath', icon: 'bath', codeIcon: 'fas fa-bath'},
    {name: 'car-side', icon: 'car-side', codeIcon: 'fas fa-car-side'},
    {name: 'baby', icon: 'baby', codeIcon: 'fas fa-baby'},
    {name: 'plug', icon: 'plug', codeIcon: 'fas fa-plug'},
    {name: 'oil-can', icon: 'oil-can', codeIcon: 'fas fa-oil-can'},
    {name: 'laptop', icon: 'laptop', codeIcon: 'fas fa-laptop'},
    {name: 'utensils', icon: 'utensils', codeIcon: 'fas fa-utensils'},
    {name: 'weight-hanging', icon: 'weight-hanging', codeIcon: 'fas fa-weight-hanging'},
    {name: 'user-md', icon: 'user-md', codeIcon: 'fas fa-user-md'},
    {name: 'dog', icon: 'dog', codeIcon: 'fas fa-dog'},
    {name: 'dumbbell', icon: 'dumbbell', codeIcon: 'fas fa-dumbbell'},
    {name: 'warehouse',  icon: 'warehouse', codeIcon: 'fas fa-warehouse'},
    {name: 'house',  icon: 'house', codeIcon: 'fas fa-house'},
    {name: 'user',  icon: 'user', codeIcon: 'fas fa-user'},
    {name: 'heart',  icon: 'heart', codeIcon: 'fas fa-heart'},
    {name: 'camera',  icon: 'camera', codeIcon: 'fas fa-camera'},
    {name: 'tree',  icon: 'tree', codeIcon: 'fas fa-tree'},
    {name: 'gamepad',  icon: 'gamepad', codeIcon: 'fas fa-gamepad'},
    {name: 'shirt',  icon: 'shirt', codeIcon: 'fas fa-shirt'},
    {name: 'desktop',  icon: 'desktop', codeIcon: 'fas fa-desktop'},
    {name: 'virus',  icon: 'virus', codeIcon: 'fas fa-virus'},
    {name: 'wine-bottle',  icon: 'wine-bottle', codeIcon: 'fas fa-wine-bottle'},
    {name: 'tooth',  icon: 'tooth', codeIcon: 'fas fa-tooth'},
    {name: 'couch',  icon: 'couch', codeIcon: 'fas fa-couch'},
    {name: 'helmet-safety',  icon: 'helmet-safety', codeIcon: 'fas fa-helmet-safety'},
    {name: 'compact-disc',  icon: 'compact-disc', codeIcon: 'fas fa-compact-disc'},
    {name: 'satellite',  icon: 'satellite', codeIcon: 'fas fa-satellite'},
    {name: 'briefcase',  icon: 'briefcase', codeIcon: 'fas fa-briefcase'},
    {name: 'screwdriver-wrench',  icon: 'screwdriver-wrench', codeIcon: 'fas fa-screwdriver-wrench'},
    {name: 'fire',  icon: 'fire', codeIcon: 'fas fa-file'},
    {name: 'gear',  icon: 'gear', codeIcon: 'fas fa-gear'},
    {name: 'mobile-screen',  icon: 'mobile-screen', codeIcon: 'fas fa-mobile-screen'},
    {name: 'lightbulb',  icon: 'lightbulb', codeIcon: 'fas fa-lightbulb'},
    {name: 'solar-panel',  icon: 'solar-panel', codeIcon: 'fas fa-solar-panel'},
    {name: 'car-battery',  icon: 'car-battery', codeIcon: 'fas fa-car-battery'},
    {name: 'music',  icon: 'music', codeIcon: 'fas fa-music'},
    {name: 'bell',  icon: 'bell', codeIcon: 'fas fa-bell'},
    {name: 'print',  icon: 'print', codeIcon: 'fas fa-print'},
    {name: 'pen',  icon: 'pen', codeIcon: 'fas fa-pen'},
    {name: 'gift',  icon: 'gift', codeIcon: 'fas fa-gift'},
    {name: 'camera-retro',  icon: 'camera-retro', codeIcon: 'fas fa-camera-retro'},
    {name: 'palette',  icon: 'palette', codeIcon: 'fas fa-palette'},
    {name: 'clock',  icon: 'clock', codeIcon: 'fas fa-clock'},
    {name: 'wind',  icon: 'wind', codeIcon: 'fas fa-wind'},
    
  ];

  // faScrewdriverWrench,
  // faFire,
  // faGear,
  // faMobileScreen,
  // faLightbulb,
  // faSolarPanel,
  // faCarBattery,
  // faMusic,
  // faBell,
  // faPrint,
  // faPen,
  // faGift,
  // faCameraRetro,
  // faPalette,
  // faClock
  
  const columns: ColumnMeta[] = [
      // {field: 'id', header: 'Id', editable: false},
      {field: 'name', header: 'Nombre', editable: true},
      {field: 'icon', header: 'Icono', editable: false},
      {field: 'options', header: 'Opciones', editable: false},
  ];

   
  library.add(
    faWarehouse, 
    faCarSide, 
    faBaby,
    faPlug,
    faOilCan,
    faLaptop,
    faUtensils,
    faWeightHanging,
    faUserMd,
    faDog,
    faDumbbell,
    faBath,
    faHouse,
    faUser,
    faHeart,
    faCamera,
    faTree,
    faGamepad,
    faShirt,
    faDesktop,
    faVirus,
    faWineBottle,
    faTooth,
    faCouch,
    faHelmetSafety,
    faCompactDisc,
    faSatellite,
    faBriefcase,
    faScrewdriverWrench,
    faFire,
    faGear,
    faMobileScreen,
    faLightbulb,
    faSolarPanel,
    faCarBattery,
    faMusic,
    faBell,
    faPrint,
    faPen,
    faGift,
    faCameraRetro,
    faPalette,
    faClock,
    faWind
    );
  
      useEffect(() => {
        getCategories();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);


    //  const show = ( severity: any, summary: any, detail: any,) => {
    //     // @ts-ignore
    //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
    // };
      const accept = async (id: string) => {
        
          let deleted = await removeCategory(id);
          console.log(deleted);
          if(deleted){
            showInfo('Confirmada', 'has aceptado');
            await  getCategories();
          }      
      }

      const reject = () => {
          showWarn('Rechazada', 'has rechazado');
      }

      const onSubmit = (
        data: { 
            name: string,
            icon: string,
        }
        ) => {
          data.name && showSuccess("Se registro", data.name);
          let datos =  data;
          if(datos){
            const categoryData: Category = {
              name: data.name,
              icon: iconCodeState || '',
              id: ""
            };
            createCategory(categoryData);
          }
          getCategories();
          console.log(datos);
          reset();
      };

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };


      // const onCellEditComplete = async (e: ColumnEvent) => {
      //     let { rowData, newValue, field, originalEvent: event } = e;
      //     console.log("Field", field);

      //     switch (field) {
      //         case 'icon': 
      //         default:
      //           if (newValue.trim().length > 0) {
      //             rowData[field] = newValue;

      //             const data = await updateCategory(rowData);

      //             if(data){
      //               show("success", "Se actualizo", rowData.name);
      //               getCategories();
      //             }
      //           }
      //             else event.preventDefault();
      //             break;
      //     }
      // };


      const isUpdatingRef = useRef(false);
      const onCellEditComplete = useCallback( async(e: ColumnEvent) => {
        // Guard contra doble ejecución simultánea
        if (isUpdatingRef.current) return;
        isUpdatingRef.current = true;
        let { rowData, newValue, field, originalEvent: event } = e;

        // 1. Validar vacío
        if (newValue === null || newValue === undefined || newValue === "") {
          event.preventDefault();
          isUpdatingRef.current = false;
          return;
        }

        if (rowData[field] === newValue) {
          event.preventDefault();
          isUpdatingRef.current = false;
          return;
        }
      

        const updatedRow = { ...rowData, [field]: newValue };

        try {
          const data = await updateCategory(updatedRow);

          if (data) {
            showSuccess("Se actualizo", "Se ha actualizado con éxito!");

            // Opciones:
            // A) Recargar todo desde la API
            getCategories();

            // B) O solo actualizar en el estado local:
            // setCategories(prev =>
            //   prev.map(cat => cat.id === updatedRow.id ? updatedRow : cat)
            // );
          }
        } catch (error) {
          console.error("Error al actualizar:", error);
          showError("Error", "No se pudo actualizar");
          event.preventDefault();
        }
         isUpdatingRef.current = false;
      }, []);

      const cellEditor = (options: ColumnEditorOptions) => {
          // if (options.field === 'icon') return viewIcons(options);
          // else return textEditor(options);
          return textEditor(options);
      };

      const textEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText 
                type="text" 
                value={options.value || ''}
                onChange={(e) => options.editorCallback!(e.target.value)} 
            />
        );
    };

    

    const iconsViewEdit = (data: any) =>{
      console.log("icon data", data);
      setCategoryDataUpdate({...data});
      console.log("setCategoryDataUpdate", categoryDataUpdate);
      setVisibleListIcon(true);
      

    }

    const onIconChange = (icon: string) => {
        const val = icon || '';
        let _category = { ...categoryDataUpdate };

        // @ts-ignore
        _category["icon"] = val;

        setCategoryDataUpdate(_category);
    };

    const updateIcon = async () => {
     
        const categoryData: Category = {
          name: categoryDataUpdate?.name,
          icon: categoryDataUpdate?.icon || '',
          id: categoryDataUpdate?.id
        };
        const data = await updateCategory(categoryData);

        if(data){
          showSuccess("Se actualizo", categoryData.name);
          getCategories();
        }
        setVisibleListIcon(false);  

        console.log(categoryData);
        
      
    }

      const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value;
          let _filters = { ...filters };
          // @ts-ignore
          _filters['global'].value = value.toString() || '';

          setFilters(_filters);
          // setGlobalFilterValue(value);
      };

      const btnIcon = (data: IconList) => {

        //console.log(icon.icon);
          const ico = data.icon?.replace(/^fas\s+/, "") || "bath";
          return (
              <>
                <button type="button" className="btn btn-dark" onClick={() =>{iconsViewEdit(data)}}>
                  <FontAwesomeIcon key={data.icon} icon={[ 'fas', `${ico}` as IconName ]} /> {data.icon}
                </button>
              </>
          );
      };

      const header = ()=>{
        // @ts-ignore
       const value = filters['global'] ? filters['global'].value : '';

       return (
           <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
               <h4 className="m-0">
                   <button type="button" className="btn btn-dark" onClick={() => setVisible(true)}>
                    <FontAwesomeIcon icon={icon({name: 'plus'})} /> 
                   Nueva categoría</button>
               </h4>
               <span className="p-input-icon-left">
                   <i className="pi pi-search" />
                   <InputText type="search" value={value || ''} onChange={(e) => 
                       onGlobalFilterChange(e)} placeholder="Buscar..." />
               </span>
           </div>
      )};

      const btnOptions = (id: string, name: string) => {

        return(
            <>
                <div className="d-flex">
                    <button onClick={()=>confirmDelete(id)} className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'trash'})} /></button>
                </div>
            </>
        );
    }

    const confirmDelete = (id: string) => {

      confirmDialog({
          message: '¿Quieres eliminar este registro?',
          header: 'Eliminar confirmación',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => accept(id),
          reject
      });
  };


      const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
      const paginatorRight = <Button type="button" icon="pi pi-download" text />;

 
    
    return (
        <>
          <div className="container-fluid">
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Lista Categorías</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                            <li className="breadcrumb-item">Lista Categorías</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            <div className="page_action">
                                {/* <button type="button" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</button> */}
                            </div>
                            <div className="p-2 d-flex">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver las últimas categorías añadidas
                </div>
                {/* <InputSwitch  key={'index01254'} checked={checkedw} onChange={(e: InputSwitchChangeEvent) =>  setCheckedw(!checkedw)} /> */}
                
            </div>
            <div className='row'>
              <div className='col-lg-12'>
                {/* <Toast ref={toast} /> */}
                {/* <ConfirmDialog /> */}
                <DataTable
                  value={categories}
                  paginator
                  rows={5}
                  editMode="cell"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  tableStyle={{ minWidth: '50rem' }}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  paginatorLeft={paginatorLeft}
                  paginatorRight={paginatorRight}
                  globalFilterFields={['id', 'name']}
                  emptyMessage="No se encontraron categorías."
                  stateStorage="session"
                  header={header}
                  filters={filters}
                  onFilter={(e) => setFilters(e.filters)}
                >
                  {columns.map(({ field, header, editable }) => (
                    <Column
                      key={field}
                      field={field}
                      header={header}
                      body={
                        field === 'icon'
                          ? (rowData) => btnIcon(rowData)
                          : field === 'options'
                          ? (rowData) => btnOptions(rowData.id, rowData.name)
                          : undefined
                      }
                      editor={editable ? (options) => cellEditor(options) : undefined}
                      onCellEditComplete={onCellEditComplete}
                    />
                  ))}
                </DataTable>
                <Dialog header="Agregar categría" visible={visible} maximizable style={{ width: '400px' }} onHide={() => setVisible(false)}>
                  <form onSubmit={handleSubmit(onSubmit)} className="text-start">
                    {/* <Toast ref={toast} /> */}
                    <div className="d-flex flex-column gap-2 ">
                        <Controller
                            name="name"
                            control={control}
                            rules={{ required: 'Nombre es requerido.' }}
                            render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name}>
                                    Nombre
                                </label>
                                <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} />
                                {getFormErrorMessage(field.name)}
                            </>       
                        )}
                        />
                        <div className="container text-center">
                          <Avatar className="p-overlay-badge icon-select" size="xlarge" shape="circle">
                            <FontAwesomeIcon key={iconCodeState} style={{ width: '100px'}} icon={[ 'fas', `${iconCodeState?.replace(/^fas\s+/, "").toString() || 'bath'}` as IconName ]} />
                          </Avatar>
                        </div>
                        <div className="container box-icons-content-reg">
                          <div className="d-flex flex-wrap justify-content-evenly">
                            {icons.map((iconItem) => (
                              <div key={iconItem.icon} className="col">
                                  <Avatar className="p-overlay-badge" size="xlarge" onClick={()=> setIconCodeState(iconItem.icon)}>
                                    <FontAwesomeIcon icon={[ 'fas', iconItem.icon.replace(/^fas\s+/, "") ]} />
                                  </Avatar>
                                  <p>{iconItem.name}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                        <Button label="Guardar" type="submit" icon="pi pi-check" className={"btn btn-dark"} />
                    </div>
                    
                  </form>
                </Dialog>
                <Dialog header="Editar categría" visible={visibleListIcon} maximizable style={{ width: '400px' }} onHide={() => setVisibleListIcon(false)}>
                  <div className="d-flex flex-column gap-2 "> 
                      <div className="container text-center">
                        <Avatar className="p-overlay-badge icon-select" size="xlarge" shape="circle">
                          <FontAwesomeIcon style={{ width: '100px'}} icon={ ['fas', categoryDataUpdate.icon?.replace(/^fas\s+/, "") as IconName] } />
                        </Avatar>
                      </div>
                      <div className="container box-icons-content-reg">
                        <div className="d-flex flex-wrap justify-content-evenly">
                          {icons.map((iconItem) => (
                            <div key={iconItem.icon} className="col">
                                <Avatar className="p-overlay-badge" size="xlarge"   onClick={() => onIconChange(iconItem.icon)}>
                                  <FontAwesomeIcon icon={[ 'fas', iconItem.icon?.replace(/^fas\s+/, "") ]} />
                                </Avatar>
                                <p>{iconItem.name}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                      <Button label="Guardar" type="submit" icon="pi pi-check" className={"btn btn-dark"}  onClick={updateIcon}  />
                  </div> 
                </Dialog>
              </div>
            </div>
          </div>
        </>
    );
}